import { useRouteError } from "react-router-dom";

import Heading from "./Components/Heading/Heading";
import "./error-page.scss";

export default function ErrorPage() {
  const error = useRouteError();
  console.error("error", error.statusText);

  return (
    <div id="error-page">
      <Heading nama="Error" job={error.statusText} />
    </div>
  );
}
